<div class="content-block content-block-confirmation has-padding">
  <img [ngClass]="(subsidiaryIsNotReady$ | async) === false ? '' : 'visibility'" class="illustration" src="{{ assetsPath }}/assets/images/content/new-account-confirm.png" alt="">

  @if (subsidiaryIsNotReady$ | async) {
    <div class="mb-4">
      <loader-spinner size="normal"/>
    </div>
  }

  @if ((subsidiaryIsNotReady$ | async) === false && (subscriptionFormError$ | async) === false) {
    <h1 data-cy="TitleNewAccountValidation" translate="PageTitles.NewAccountValidation"></h1>
  }

  <div class="row justify-content-center">
    @if (subsidiaryIsNotReady$ | async) {
      <p class="text-left" innerHTML="{{ 'NewAccount.Validation.CreationText' | translate }}"></p>
    }
    @if ((subsidiaryIsNotReady$ | async) === false && (subscriptionFormError$ | async) === false) {
      <p class="text-left" innerHTML="{{ 'NewAccount.Validation.ConfirmationText' | translate }}"></p>
    }
  </div>

  @if ((subscriptionFormError$ | async) === false) {
    @if ((subsidiaryIsNotReady$ | async) === false && selectedSubsidiary$ | async; as selectedSubsidiary) {
      <div class="mt-4">
        <a target="_blank" data-cy="OpenTabSubsidiaryDetailUsers" [routerLink]="subsidiaryDetailUsersPath(selectedSubsidiary.entity.subsidiaryId)" routerLinkActive="active" class="btn btn-primary">
          {{ 'NewAccount.Validation.InviteUsers' | translate }}
        </a>
        <button [disabled]="!selectedSubsidiary.entity.isCgvAccepted" (click)="goToTenant('/admin-tools/options')" class="btn btn-primary ml-4">
          {{ 'NewAccount.Validation.ConfigSubsidiary' | translate }}
        </button>
        <button [disabled]="!selectedSubsidiary.entity.isCgvAccepted" (click)="goToTenant()" class="btn btn-primary ml-4">
          {{ 'NewAccount.Validation.Button' | translate }}
        </button>
      </div>
    } @else if (aMinutePassed$ | async) {
      <div class="mt-4">
        <p>{{ 'NewAccount.Validation.TooLongText' | translate }}</p>
        <button [routerLink]="subsListList" class="btn btn-primary ml-4">
          {{ 'PageTitles.Subsidiaries' | translate }}
        </button>
      </div>
    }
  }

  @if ((subscriptionFormError$ | async)) {
    <div>
      {{ 'NewAccount.Validation.Error' | translate }}
    </div>
  }
</div>
